









import { Component, Prop, Vue } from 'vue-property-decorator';
import I18n from '@/i18n/I18n';

@Component
export default class CategoryIcon extends Vue {
    @Prop({ type: String, required: false })
    svg!: string;

    @Prop({ type: String, required: false, default: '#5BBB89' })
    color!: string;

    @Prop({ type: String, required: false, default: () => I18n.t('main.marker') })
    title!: string;

    @Prop({ type: Boolean, required: false, default: false })
    active!: boolean;
}
